import { VFC } from 'react'

export const Footer: VFC = () => {
  return (
    <footer className='h-10 w-full bg-pandacco text-white text-center'>
      <small className='leading-10'>&copy;2025 Pandacco</small>
    </footer>
  )
}